import { Schema as S } from "effect";

/**
 * Insurance Type Schema
 */
export const InsuranceTypeSchema = S.Union(
  [S.Literal("GKV"),
  S.Literal("PKV"),
  S.Literal("SELFPAY"),
  S.Literal("UNKNOWN")]
);

export type InsuranceType = S.Schema.Type<typeof InsuranceTypeSchema>;

/**
 * Check Quarterly Coverage Response Schema
 *
 * Returns coverage status for the current billing quarter.
 * GKV patients need a valid proof per quarter for billing.
 */
export const CheckQuarterlyCoverageResponseSchema = S.Struct({
  /** Whether patient has valid coverage for current quarter */
  hasCurrentQuarterCoverage: S.Boolean,
  /** Current quarter identifier (e.g., "2024-Q4") - present if has coverage */
  coverageQuarter: S.optional(S.String),
  /** Insurance type of the patient */
  insuranceType: InsuranceTypeSchema,
  /** Previous insurer IKNR (for pre-fill when no current coverage) */
  previousInsurerIknr: S.optional(S.String),
  /** Previous insurer name (for pre-fill) */
  previousInsurerName: S.optional(S.String),
  /** Whether patient has any previous GKV coverage on record */
  hasPreviousCoverage: S.Boolean,
  /** Last card read date (ISO 8601) for UI context */
  lastCardReadDate: S.optional(S.String),
  /** Coverage date (ISO 8601) if current quarter coverage exists */
  coverageDate: S.optional(S.String),
  /** Current insurer IKNR (if current quarter coverage exists) */
  insurerIknr: S.optional(S.String),
  /** Current insurer name (if current quarter coverage exists) */
  insurerName: S.optional(S.String),
});

export type CheckQuarterlyCoverageResponse = S.Schema.Type<
  typeof CheckQuarterlyCoverageResponseSchema
>;
